import {
  getTreatmentPlans as getTreatmentPlansApi,
  showTreatmentPlan as showTreatmentPlanApi,
  generatePdf as generatePdfApi,
  drawSignatureOnTxpPdf as drawSignatureOnTxpPdfApi,
  sendReceipt as sendReceiptApi,
  createTreatmentPlanProgress as createTreatmentPlanProgressApi,
  getTreatmentPlanProgresses as getTreatmentPlanProgressesApi,
  updateTreatmentPlanProgress as updateTreatmentPlanProgressApi
} from './api'

let getTreatmentPlans = (params) => dispatch => {
  return getTreatmentPlansApi(params)
}

let showTreatmentPlan = (treatmentPlanId) => dispatch => {
  return showTreatmentPlanApi(treatmentPlanId)
}

let generatePdf = (treatmentPlanId) => dispatch => {
  return generatePdfApi(treatmentPlanId)
}

let drawSignatureOnTxpPdf = (treatmentPlanId, data) => dispatch => {
  return drawSignatureOnTxpPdfApi(treatmentPlanId, data);
};

let sendReceipt = (treatmentPlanId, params) => dispatch => {
  return sendReceiptApi(treatmentPlanId, params)
}

let createTreatmentPlanProgress = (treatmentPlanId, data) => dispatch => {
  return createTreatmentPlanProgressApi(treatmentPlanId, data)
}

let getTreatmentPlanProgresses = (treatmentPlanId) => dispatch => {
  return getTreatmentPlanProgressesApi(treatmentPlanId)
}

let updateTreatmentPlanProgress = (treatmentPlanId, treatmentPlanProgressId, data) => dispatch => {
  return updateTreatmentPlanProgressApi(treatmentPlanId, treatmentPlanProgressId, data)
}

export {
  getTreatmentPlans,
  showTreatmentPlan,
  generatePdf,
  drawSignatureOnTxpPdf,
  sendReceipt,
  createTreatmentPlanProgress,
  getTreatmentPlanProgresses,
  updateTreatmentPlanProgress
}
